import apiClient from './apiClient';

export async function ping() {
  const res = await apiClient.post('/activity/ping');
  return res.data.data;
}

export async function getSummary(params) {
  const res = await apiClient.get('/activity/summary', { params });
  return res.data.data;
}

export async function getSessions(params) {
  const res = await apiClient.get('/activity/sessions', { params });
  return res.data.data;
}
